const doc = [({"ko":({"adminButtonUser":({"backToUserIndex":"회원 목록으로 돌아가기"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;